/**
 * /deliverables — each day's items totaled across every school, for the
 * packing bench.
 *
 * Aug 2026 chef-sidebar split: this page IS the old Shopping List's
 * Deliverables tab, promoted to its own sidebar row (canonical nav
 * position 7).
 *
 * Implementation is shared with /shopping-list and /recipes — see
 * `ChefKitchenPage` in `pages/shopping-list.tsx`.
 */

import { ChefKitchenPage } from '@/pages/shopping-list'

export function DeliverablesPage() {
  return <ChefKitchenPage view="deliverables" />
}
